/**
 * Âm thanh thông báo:
 * - yeu_cau / nhan / da_tt → thong-bao-3s.wav
 * - chuong → chuong-3s.wav (~3s)
 *
 * Gọi phatTinhTinh() trong cùng lượt click (trước await) để không bị chặn autoplay.
 */

const PUBLIC = process.env.PUBLIC_URL || "";
const URL_THONG_BAO = `${PUBLIC}/sounds/thong-bao-3s.wav`;
const URL_CHUONG = `${PUBLIC}/sounds/chuong-3s.wav?v=1`;

/** @type {Record<string, HTMLAudioElement>} */
const cache = {};
let dangPhat = null;
let lanPhatGanNhat = 0;
const DEBOUNCE_MS = 800;

function layAudio(url) {
  if (typeof window === "undefined") return null;
  if (!cache[url]) {
    const a = new Audio(url);
    a.preload = "auto";
    a.loop = false;
    try {
      a.load();
    } catch {
      // ignore
    }
    cache[url] = a;
  }
  return cache[url];
}

function dungTatCa() {
  Object.values(cache).forEach((a) => {
    try {
      a.pause();
      a.currentTime = 0;
    } catch {
      // ignore
    }
  });
  if (dangPhat && !Object.values(cache).includes(dangPhat)) {
    try {
      dangPhat.pause();
    } catch {
      // ignore
    }
  }
  dangPhat = null;
}

function urlTheoLoai(loai) {
  return loai === "chuong" ? URL_CHUONG : URL_THONG_BAO;
}

/** Unlock WebKit: play muted trong user gesture rồi pause (chỉ preload thì iOS vẫn chặn). */
export function unlockAmThanh() {
  try {
    [URL_THONG_BAO, URL_CHUONG].forEach((url) => {
      const a = layAudio(url);
      if (!a) return;
      const mutedTruoc = a.muted;
      a.muted = true;
      const p = a.play();
      const xong = () => {
        try {
          a.pause();
          a.currentTime = 0;
        } catch {
          // ignore
        }
        a.muted = mutedTruoc;
      };
      if (p && typeof p.then === "function") {
        p.then(xong).catch(xong);
      } else {
        xong();
      }
    });
  } catch {
    // ignore
  }
}

/** Gắn 1 lần listener toàn trang để unlock sau thao tác đầu. */
export function dangKyUnlockAmThanh() {
  if (typeof window === "undefined") return () => {};
  layAudio(URL_THONG_BAO);
  layAudio(URL_CHUONG);
  const mo = () => {
    unlockAmThanh();
    window.removeEventListener("pointerdown", mo);
    window.removeEventListener("keydown", mo);
  };
  window.addEventListener("pointerdown", mo, { once: true });
  window.addEventListener("keydown", mo, { once: true });
  return () => {
    window.removeEventListener("pointerdown", mo);
    window.removeEventListener("keydown", mo);
  };
}

/**
 * Phát đúng 1 loại âm thanh (dừng mọi file đang chạy trước đó).
 * @param {"yeu_cau"|"nhan"|"da_tt"|"chuong"} [loai]
 */
export function phatTinhTinh(loai = "yeu_cau") {
  if (typeof window === "undefined") return;
  const now = Date.now();
  if (now - lanPhatGanNhat < DEBOUNCE_MS) return;
  lanPhatGanNhat = now;

  try {
    dungTatCa();
    const url = urlTheoLoai(loai);
    const a = layAudio(url);
    if (!a) return;
    a.loop = false;
    a.volume = 1;
    try {
      a.currentTime = 0;
    } catch {
      // ignore
    }
    dangPhat = a;
    a.onended = () => {
      if (dangPhat === a) dangPhat = null;
    };
    const p = a.play();
    if (p && typeof p.catch === "function") {
      p.catch(() => {
        if (dangPhat === a) dangPhat = null;
      });
    }
  } catch {
    // ignore
  }
}
